import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SettingsService } from '../../service/settings.service';
import { deepCopy, removeUndefined } from 'na-lib';

@Component({
    selector: 'app-work-task-template-dialog-incoming-outgoing',
    templateUrl: './work-task-template-dialog-incoming-outgoing.component.html',
    standalone: false
})
export class WorkTaskTemplateDialogIncomingOutgoingComponent {
  type:any
  tridyTypeData:any = {}
  tridyTypeForm!:FormGroup
  tridyAction:boolean
  tasktemplateUserRights_update:any
  contentTypesList:any = []
  tridySelection = [
    {
      translation:'workTask.select_list',
      value:'scan',
    },
    {
      translation:'workTask.select_scan',
      value:'select'
    },
    {
      translation:'workTask.select_opticalScan',
      value:'opticalScan'
    }
  ]
  predicates:any=[]

  multiplicityList = [
    {//"0-*":
      translation:"workTask.multiplicity.endless",
      value:'0-*',
    },
    {//"1-*":
      translation:"workTask.multiplicity.atLEast_once",
      value:'1-*'
    },
    {//"0-1":
      translation:"workTask.multiplicity.maxOne",
      value:"0-1"
    },
    {//"1-1":
      translation:"workTask.multiplicity.one",
      value:"1-1"
    },
    {//"":
      translation:"workTask.multiplicity.custom",
      value:"custom"
    }
  ]

  constructor(
    public dialogRef: MatDialogRef<WorkTaskTemplateDialogIncomingOutgoingComponent>,
    private fb: FormBuilder,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private settingsService: SettingsService

  ){
    dialogRef.disableClose = true;
  }


  ngOnInit():void{
    this.tasktemplateUserRights_update = this.settingsService.modulesRolesRights$.value['workTaskTemplates']['U']

    this.settingsService.modulesRolesRights$.subscribe( value => {
      this.tasktemplateUserRights_update = this.settingsService.modulesRolesRights$.value['workTaskTemplates']['U']
    })

    if(this.data['type']){
      this.type = this.data['type']
    }
    this.tridyTypeForm = this.fb.group({
      actions: [],
      displayTitle:[],
      contentTypeId: [, Validators.required],
      multiplicity:[],
      source:[],
      min:[],
      max:[],
      amount:[],
      amountInteger:[],
      amountUnit:[],
      sources:[],
      tridyAction: [''],
      predicates:[]
    })

    if(this.data['contentTypes']) this.contentTypesList = this.data['contentTypes']

    // if(this.data.values){
      this.tridyTypeData = deepCopy(this.data.values)
      let { actions, displayTitle, contentTypeId, multiplicity, source, amount, amountInteger, amountUnit, sources,predicates, tridyAction} = this.tridyTypeData
      let min, max
      if(predicates)
        this.predicates = predicates
      else
        this.predicates = []

      if(multiplicity){
        const values = multiplicity.split('-')
        min = values[0]
        max = values[1]
        if(multiplicity != "0-*" && multiplicity != "1-*" && multiplicity != "0-1" && multiplicity != "1-1" ){
          multiplicity = "custom"
        }
      }

      this.tridyTypeForm.patchValue({
        actions: actions ? actions : [],
        displayTitle: displayTitle ? displayTitle : undefined,
        contentTypeId: contentTypeId ? contentTypeId : undefined,
        multiplicity:multiplicity ? multiplicity : "0-*",
        source:source ? source : undefined,
        sources:sources ? sources : undefined,
        min: min ? min : undefined,
        max: max ? max : undefined,
        amount: amount ? amount: 'none',
        amountInteger: amountInteger ? amountInteger : false,
        amountUnit:amountUnit ? amountUnit : undefined,
        tridyAction: tridyAction || '',
        predicates:predicates? predicates: undefined
      })

       // Set `tridyAction` based on `actions` array, if it exists
      if (actions && actions.length > 0) {
        this.tridyTypeForm.patchValue({
          tridyAction: actions[0],
        });
        this.tridyAction = true;
      } else {
        this.tridyTypeForm.patchValue({ tridyAction: '' });
        this.tridyAction = false;
      }

      if(this.type!='Outgoing'){
        this.tridyTypeForm.get('sources').setValidators([Validators.required])
        this.tridyTypeForm.patchValue({sources:sources ? sources : ['select']})
        this.tridyTypeForm.patchValue({ tridyAction: tridyAction ? tridyAction : '' });

        if(source){
          switch(source){
            case 'select':{
              const sourcesAdd = sources
              if(!sourcesAdd.includes('select'))
              this.tridyTypeForm.patchValue({sources:['select']})
              break;
            }
            case 'scan':{
              let sourcesAdd
              if(sourcesAdd && sourcesAdd.length !=0){
                sourcesAdd = sources
              }else{
                sourcesAdd = []
              }

              if(!sourcesAdd.includes('scanNFC')  )
              sourcesAdd.push('scanNFC')

              if(!sourcesAdd.includes('scanQR'))
              sourcesAdd.push('scanNFC')

              this.tridyTypeForm.patchValue({sources:sources})

              // this.tridyTypeForm.patchValue({sources:['scanNFC','scanQR']})
              break;
            }
            default:{
              this.tridyTypeForm.patchValue({sources:sources})
              // this.tridyTypeForm.patchValue({sources:['select']})
              break;
            }
          }
        }
      }

      if(actions && actions.length > 0){
        this.tridyAction = true
      }
    // }
  }


  changeActionValue() {
    if(this.tridyAction)
    this.tridyAction = false
    else
    this.tridyAction = true
  }
  onCancel(){
    this.dialogRef.close(['', false])
  }

  onDone(){
    let data:any = {}
    switch(this.type){
      case 'Incoming':{
        if(this.tridyTypeForm.value.multiplicity == 'custom'){
          let min, max
          min = this.tridyTypeForm.value.min
          max = this.tridyTypeForm.value.max
          let multiplicity

          if(min || min ==0 || max || max ==0 ){
            multiplicity = this.tridyTypeForm.value.min +'-' + this.tridyTypeForm.value.max
          }else{
            multiplicity = "0-*"
          }
          this.tridyTypeForm.patchValue( {multiplicity: multiplicity})

        }

        if(this.tridyTypeForm.value.source && !this.tridyTypeForm.value.sources ){
          let valueSources = []
          switch(this.tridyTypeForm.value.source){
            case 'select':{
              this.tridyTypeForm.patchValue({sources:['select']})
              break;
            }

            case 'scan':{
              this.tridyTypeForm.patchValue({sources:['scanNFC','scanQR']})
              break;

            }
            default:{
              this.tridyTypeForm.patchValue({sources:['select']})
              break;
            }
          }
        }

        if(this.tridyTypeForm.value.sources && this.tridyTypeForm.value.sources[0]){
          const sources = this.tridyTypeForm.value.sources[0]
          switch(sources){
            case 'select':{
              this.tridyTypeForm.patchValue({source:'select'})
              break;
            }
            case 'scanQR':{
              this.tridyTypeForm.patchValue({source:'scan'})
              break;
            }
            case 'scanNFC':{
              this.tridyTypeForm.patchValue({source:'scan'})
              break;
            }
            default:{
              this.tridyTypeForm.patchValue({sources:'select'})
              break;
            }
          }
        }
        break;
      }
      case 'Outgoing': {
        const tridyActionValue = this.tridyTypeForm.get('tridyAction')?.value;
        if (tridyActionValue) {
          const selectedAction = this.tridyTypeForm.get('tridyAction')?.value;
          this.tridyTypeForm.patchValue({ actions: selectedAction ? [selectedAction] : [] });
        } else {
          this.tridyTypeForm.patchValue({ actions: [] });
        }
        break;
      }
    }
    data['tridyAction'] = this.tridyTypeForm.get('tridyAction')?.value;
    data = {
      ...removeUndefined(this.tridyTypeForm.value),
      tridyAction: this.tridyAction
    };
    if(data['amount']=='none'){
      delete data['amount']
    }

    if(data.predicates?.length==0)
    delete data.predicates

    if(data.actions?.length==0)
    delete data.actions

    this.dialogRef.close([data, true])
  }
  onTridyActionChange(value: string): void {
    this.tridyAction = value !== '';
    this.tridyTypeForm.patchValue({ tridyAction: value });
  }

  onPredicatesChange(predicates: any[]) {
    this.predicates = predicates
    this.tridyTypeForm.patchValue({predicates: this.predicates})
  }

}
